/**
 * Project : workspace
 * File    : InvoiceBarcodeRow.kt
 * Created : AUTO-GENERATED by scripts/add_kdoc.py
 */

package presentation.screens.business.invoice.component

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.parmartechnologies.core.feature.invoice.model.CustomerInvoice
import io.github.alexzhirkevich.qrose.oned.BarcodeType
import io.github.alexzhirkevich.qrose.oned.rememberBarcodePainter
import io.github.alexzhirkevich.qrose.rememberQrCodePainter

@Composable
/**
 * Executes the invoice barcode row operation.
 *
 * @receiver TODO
 * @param invoice The invoice.
 * @return Unit – no return value.
 */
fun InvoiceBarcodeRow(invoice: CustomerInvoice?) {
    Row(
        modifier = Modifier.fillMaxWidth().height(160.dp)
            .padding(start = 16.dp, end = 16.dp, bottom = 8.dp)
    ) {
        Image(
            painter = rememberBarcodePainter(invoice?.InvoiceId.toString(), BarcodeType.Code128),
            contentDescription = "Barcode for invoice ${invoice?.InvoiceId}",
            modifier = Modifier.fillMaxWidth().fillMaxHeight().weight(0.6f)
        )
        Image(
            painter = rememberQrCodePainter(invoice?.ShareLink ?: ""),
            contentDescription = "Barcode for invoice ${invoice?.InvoiceId}",
            modifier = Modifier.fillMaxWidth().fillMaxHeight().weight(0.4f)
                .padding(top = 16.dp, bottom = 16.dp)
        )
    }
}